import {
  ImpButton,
  ImpContainer,
  ImpFlex,
  ImpInput,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { useEffect, useState } from 'react';

import { useVerifyDob } from '../../api/pin/verifyDob';
import { setLoading } from '../../app/applicationScreenSlice';
import { useImpState } from '../../app/hooks';
import { formatDob } from '../../utils/formatUtils';
import {
  validateBirthDate,
  ValidationResponse,
} from '../../utils/validateUtils';

export function VerifyDobPage() {
  const { language, appScreenState, dispatch } = useImpState();
  const [birthday, setBirthday] = useState('');
  const [birthdayError, setBirthdayError] = useState(ValidationResponse.empty);

  const verifyDobMutation = useVerifyDob();

  useEffect(() => {
    if (birthday.length < 10) setBirthdayError(ValidationResponse.empty);
    if (birthday.length === 10) setBirthdayError(validateBirthDate(birthday));
  }, [birthday]);

  function handleContinueClick() {
    if (birthdayError !== ValidationResponse.valid) return;

    dispatch(setLoading(true));
    const [month, day, year]: string[] = birthday.split('/');
    verifyDobMutation.mutate({
      year: Number(year),
      month: Number(month),
      day: Number(day),
    });
  }

  const buttonState = appScreenState.loading
    ? 'submitting'
    : birthdayError === ValidationResponse.valid
      ? 'enabled'
      : 'disabled';

  return (
    <ImpContainer>
      <ImpFlex direction="column" align="center" fluid>
        <ImpSpacer height="xl" />
        <ImpText typography="headline3">{language.loginDobHeader}</ImpText>
        <ImpSpacer height="xl" />
        <ImpInput
          label={language.loginDobField}
          value={birthday}
          showError={
            ![ValidationResponse.valid, ValidationResponse.empty].includes(
              birthdayError
            )
          }
          errorMessage={language.invalidServiceDob}
          inputStyle="centered"
          onChange={(e) => {
            setBirthday(formatDob(e.target.value));
          }}
          onBlur={() => setBirthdayError(validateBirthDate(birthday))}
          maxLength={10}
          onEnter={handleContinueClick}
          isDisabled={buttonState === 'submitting'}
        />
        <ImpSpacer height="xl" />
        <ImpButton
          onClick={handleContinueClick}
          state={buttonState}
          size="fill"
        >
          {language.continueBtn}
        </ImpButton>
        <ImpSpacer height="xl" />
      </ImpFlex>
    </ImpContainer>
  );
}
